import { render } from "./Cherished_desire_detail.vue?vue&type=template&id=04758666&scoped=true"
import script from "./Cherished_desire_detail.vue?vue&type=script&lang=js"
export * from "./Cherished_desire_detail.vue?vue&type=script&lang=js"

import "./Cherished_desire_detail.vue?vue&type=style&index=0&id=04758666&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04758666"]])

export default __exports__